import lodashDebounce from 'lodash/debounce';
import { UAParser } from 'ua-parser-js';
import { ReadonlyHeaders } from 'next/dist/server/web/spec-extension/adapters/headers';
import { listPredefinedDates } from 'constants/listPredefinedDates';

export function isServer() {
  return typeof window === 'undefined';
}

export function isMobile(headers?: () => ReadonlyHeaders) {
  if (isServer()) {
    if (headers) {
      const userAgent = headers().get('user-agent');
      if (userAgent) {
        const parser = new UAParser();
        parser?.setUA(userAgent);
        const result = parser?.getResult();
        const isMobile = result?.device?.type === 'mobile' || result?.device?.type === 'tablet' || false;
        return isMobile;
      }
    }
    return false;
  }

  return window.matchMedia('(max-width: 640px)').matches;
}

export const debounce = lodashDebounce;

export function convertObjectToQueryParam(params: object) {
  return Object.keys(params).reduce((acc, cur, idx) => {
    const value = params[cur as keyof typeof params];
    if (value) {
      return `${acc}${idx === 0 ? '?' : '&'}${cur}=${value}`;
    }

    return acc;
  }, '');
}

export function removeEmptyParams(params: object) {
  return Object.keys(params).reduce((acc, cur) => {
    if (params[cur as keyof typeof params] !== '' && params[cur as keyof typeof params] !== 'undefined') {
      acc[cur as keyof typeof params] = params[cur as keyof typeof params];
    }
    return acc;
  }, {});
}

export function setItemOnStorage(key: string, value: string) {
  if (!isServer()) localStorage?.setItem(key, value);
}

export function getItemFromStorage(key: string) {
  if (isServer()) return null;
  return localStorage?.getItem(key);
}

export function updateUrlQueryParam({ param, value }: { param: string; value: string }) {
  if (!isServer()) {
    const url = new URL(window.location.href);
    url?.searchParams?.set(param, value);
    window?.history?.pushState({}, '', url);
  }
}

export function deleteUrlQueryParam({ param }: { param: string }) {
  if (!isServer()) {
    const url = new URL(window.location.href);
    if (url.searchParams.get(param)) {
      url.searchParams.delete(param);
      window?.history.pushState({}, '', url);
    }
  }
}

export const getDateSearch = (date: string) => {
  const dateSearch = listPredefinedDates.find((item) => item.dateId === date);
  if (dateSearch) return dateSearch?.param;
  return '';
};

export function getMainUrl() {
  const urls: { [key: string]: string } = {
    stage: 'https://stage.sympla.com.br',
    homolog: 'https://homolog.sympla.com.br',
    prod: 'https://www.sympla.com.br',
  };

  return urls[process.env.NEXT_PUBLIC_CLOUD_FRONT_BUNDLE_ENVIRONMENT || 'stage'];
}

export function getMainUrlOrganizer() {
  const urls: { [key: string]: string } = {
    stage: 'https://organizador.svc-stage.sympla.com.br',
    homolog: 'https://organizador.svc-homolog.sympla.com.br',
    prod: 'https://organizador.sympla.com.br',
  };

  return urls[process.env.NEXT_PUBLIC_CLOUD_FRONT_BUNDLE_ENVIRONMENT || 'prod'];
}
